var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gachi gachi-signup",class:{ 'gachi-login': _vm.isMobile },attrs:{"id":"gachi"}},[_c('login-header'),_c('router-view'),_c('main-footer'),_c('common-alert'),_c('address-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }